import VuexPersistence from 'vuex-persist';

const VuexSessionStorage = new VuexPersistence({
  storage: window.sessionStorage,
  reducer: (state) => ({
    CRM_NAVIGATION: state.CRM_NAVIGATION,
  }),
});

export default VuexSessionStorage;
